export default __webpack_public_path__ + "static/media/Screenshot-at-2018-11-16-14-42-52.5d53d4ac.png";